import { Ticketing_API_URL } from "../../configs/WebServiceUrl";

const ticketsURL = `${Ticketing_API_URL}/api/externalUser/ticket/`;

// export const viewTickets = `${ticketsURL}getAllTicketsByUserId`;
export const viewTickets = `${Ticketing_API_URL}/api/schoolUser/ticket/getAllTicketsByUserId`;
// export const createTicket = `${ticketsURL}createTicket`;
export const createTicket = `${Ticketing_API_URL}/api/schoolUser/ticket/createTicket`;
export const getIssues = `${ticketsURL}getIssues/4`;
// https://web1024.docmaster.in:4501/api/externalUser/ticket
export const getId = `${Ticketing_API_URL}/api/schoolUser/verify-school-register`;
